import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import AddressForm from '../../../components/forms/addressForm/AddressForm'
import AddressView from '../AddressView'
import { sameAddress } from '../../../constants/address'
import { mappingAddressData } from '../../../utils/addressUtil'
import {
  saveAddressDeliveryDocument,
  updateAddressDeliveryDocument,
} from '../../../redux/actions/address'
import { startLoading, doneLoading } from '../../../utils/loading'
import ButtonPanel from '../../ButtonPanel'
import { PROPOSAL, SUB_PROJECT } from '../../../constants/project'

export default function AddressDeliveryDocument({
  schema,
  isEditAll,
  addressWork,
  addressCard,
  ...props
}) {
  const { type, isEdit, onChangeIsEdit, showCommandButton, isSubProject } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const { register, handleSubmit, errors, control, setValue, reset, clearErrors } = useForm()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveUpdateAddressDeliveryDocument = async (resquest) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (resquest.id) {
        response = await updateAddressDeliveryDocument(
          resquest,
          projectId,
          resquest.id,
          type,
          isSubProject ? SUB_PROJECT : PROPOSAL
        )
      } else {
        response = await saveAddressDeliveryDocument(
          resquest,
          projectId,
          type,
          isSubProject ? SUB_PROJECT : PROPOSAL
        )
      }
      setFormSchema(response)
      onChangeIsEdit(false)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('onSubmit', data)
    let saveData
    if (data.sameAddress === sameAddress.SAME_WORK) {
      saveData = addressWork
    } else if (data.sameAddress === sameAddress.SAME_CARD) {
      saveData = addressCard
    } else {
      saveData = data
    }
    const resquest = mappingAddressData(formSchema, saveData)
    handleSaveUpdateAddressDeliveryDocument(resquest)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.title}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit && showCommandButton ? (
          <AddressForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            reset={reset}
            clearErrors={clearErrors}
            haveSameAddressRadio={true}
            addressWork={addressWork}
            addressCard={addressCard}
          ></AddressForm>
        ) : (
          <div>
            <AddressView data={formSchema} />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.title}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </>
  )
}
